module.exports = __webpack_public_path__ + "img/invoice-check.c87893fd.svg";